import { Spinner } from "@blueprintjs/core";
import { ButtonView } from "common/views/button/Button.view";
import Label from "core/components/label/Label";
import ServiceRegistry from "core/util/ServiceRegistry";
import * as React from "react";
import styled from "styled-components";
import TopicComponentConfig from "./component/topic/TopicComponentConfig";
import TopicDisplayMode from "./component/topic/TopicDisplayMode";
import TopicListComponent from "./component/topic/TopicListComponent";
import TopicListConfig from "./component/topic/TopicListConfig";
import Topic from "./entity/Topic";
import { IconNames } from "@blueprintjs/icons";
import Icon from "common/views/icon/Icon";

export interface IFeaturedTopicsProps {
	listConfig: TopicListConfig;
	topicConfig: TopicComponentConfig;
	params: any;
	onTopicNavigate?: (topic: Topic, currentDepth: number, reply: boolean) => void;
	transientTopics?: Topic[]; // append for form
	//mode: TopicDisplayMode;
	currentDepth?: number;
	sortParam?: string;
	pageSizeParam?: number;
	topicSearch?: string;
	pushParamAction?: (name, topic) => void;
	tagIdsParam?: number[];
    searchValue?:string;
    tagsEnabled?: boolean;
    setExcludedTopicIds?: (topicIds: number[]) => void;
    excludedTopicIds?: number[];
    showBookmarkTopics?: boolean;
    writePermision?: boolean;
}
interface IFeaturedTopicsState{
    pageSize?: number;
    visible?:boolean;
    collapsed:Boolean;
    
}
const FloatRight = styled.div`
    float:right;
`;

const FeaturedBox = styled.div`
    background-color: #E8E8E8;
    padding: 5px 10px;
    border-radius: 5px;
`;

class FeaturedTopics extends React.Component<IFeaturedTopicsProps,IFeaturedTopicsState> {

    constructor(props) {
        super(props);
        this.state = {pageSize:3,visible:true,collapsed:false};
    }

    public async componentDidMount() {
        let {params,topicConfig,listConfig,onTopicNavigate} = this.props;
              
       let res:any = await ServiceRegistry.getQueryService().findMany(Topic, {...params,pageSize:3,featured:true});
       if(res && res.data && res.data.entities && res.data.entities.length)
            this.setState({visible:true});
       else
            this.setState({visible:false});
        
    }

    public render() {
        let {params,topicConfig,listConfig,onTopicNavigate,pushParamAction,tagsEnabled,setExcludedTopicIds,excludedTopicIds,searchValue,tagIdsParam} = this.props;
        //hide if user is searching or filtering
        //if(this.state.visible && !( (this.props.tagIdsParam && this.props.tagIdsParam.length) || this.props.searchValue)){
        if(this.state.visible){
            return (
                <React.Fragment>
                    <br/>
                    <FeaturedBox>
                    <Label k="topics.featured" v="Featured" />
                    <FloatRight>
                        <ButtonView viewKey="topics.featured.hide" icon={this.state.collapsed?IconNames.CHEVRON_RIGHT:IconNames.CHEVRON_DOWN}
                                onClick={(e)=>this.setState({collapsed:!this.state.collapsed})}>
                            {this.state.collapsed?
                            (<React.Fragment><Label k="topics.featured.show" v="Show Featured" /><Icon icon={IconNames.CHEVRON_RIGHT}/></React.Fragment>):
                            (<React.Fragment><Label k="topics.featured.hide" v="Hide Featured" /><Icon icon={IconNames.CHEVRON_DOWN}/></React.Fragment>)}
                        </ButtonView>
                    </FloatRight><br/><br/>
                    {!this.state.collapsed && (
                    <React.Fragment>
                        <TopicListComponent
                            pushParamAction={pushParamAction}
                            mode={TopicDisplayMode.OVERVIEW}
                            pageSizeParam={this.state.pageSize}
                            /*topicSearch={this.state.searchValue || pageParams[PARAM_FORUM_QUERY]}*/
                            /*params={{...params,ids:this.state.topicIds,featured:true}}*/
                            params={{...params,featured:true}}
                            topicConfig={topicConfig}
                            listConfig={listConfig}
                            onTopicNavigate={onTopicNavigate}
                            currentDepth={0}
                            //hasData= {(visiblity) => ((!this.state.visible && visiblity) || (this.state.visible && !visiblity)) && this.setState({visible:visiblity})}
                            searchValue={searchValue}
                            tagIdsParam={tagIdsParam}
                            tagsEnabled={tagsEnabled}
                            setExcludedTopicIds={setExcludedTopicIds}
                            excludedTopicIds={excludedTopicIds}
                                    showBookmarkTopics={this.props.showBookmarkTopics}
                                    writePermision={this.props.writePermision}
                        />
                        <FloatRight>
                            <ButtonView viewKey="topics.featured.more" onClick={(e)=>this.setState({pageSize:this.state.pageSize+3})}>
                                <Label k="topics.featured.more" v="See More Featured" />
                            </ButtonView>
                        </FloatRight>
                        <br/>
                    </React.Fragment>)}
                    </FeaturedBox>
                    <br/>
                </React.Fragment>
            );
        } else {
            return <span />;
        }

    }
    
}

export default FeaturedTopics;


// WEBPACK FOOTER //
// ./src/panels/forum/FeaturedTopics.tsx